var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"charts"}})}
var staticRenderFns = []

export { render, staticRenderFns }